import { relations } from 'drizzle-orm'
import { bigint, pgEnum, pgTable } from 'drizzle-orm/pg-core'
import { getIdReference } from '../common/utils'
import { employees } from './employee'
import { skills } from './skill'

// Skill level enum
export const skillLevelEnum = pgEnum('skill_level', [
  'beginner',
  'intermediate',
  'expert',
])

// Employee-Skill relationship junction table
export const employeeSkills = pgTable('employee_skills', {
  id: bigint({ mode: 'number' }).primaryKey().generatedAlwaysAsIdentity(),
  employeeId: getIdReference(() => employees.id),
  skillId: getIdReference(() => skills.id),
  level: skillLevelEnum().notNull(),
})

// Employee skills relations
export const employeeSkillsRelations = relations(employeeSkills, ({ one }) => ({
  employee: one(employees, {
    fields: [employeeSkills.employeeId],
    references: [employees.id],
  }),
  skill: one(skills, {
    fields: [employeeSkills.skillId],
    references: [skills.id],
  }),
}))
